module.exports = __webpack_public_path__ + "img/USPMLogo - Dark.96380b58.png";